// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle, HelpConditional } from 'teller-online-libraries/help';

export const AUTHENTICATION_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.Authentication,
        order: 9,
        conditions: [HelpConditional.Users],
        bookmark: 'how-do-i-create-account',
        title: helpTitle('how-do-i-create-account'),
        body: '<p>To sign up, click <b>Sign In</b> in the header (on a phone it is the person '
            + 'icon, :account_circle:), then click the <b>Sign up</b> link on the sign-in page. '
            + 'You can also use the sign-up link in the email receipt of a previous payment.</p>'
            + '<p>Fill in the form and click <b>Sign Up</b>. A verification code is then sent to '
            + 'the email address you provided. Enter the code and click <b>Verify Email</b> to '
            + 'finish.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Authentication,
        order: 17,
        conditions: [HelpConditional.Users],
        bookmark: 'forgot-password',
        title: helpTitle('forgot-password'),
        body: '<p>If you have forgotten your password, click the <b>Forgot your password?</b> link '
            + 'on the Sign In page, enter the email address you signed up with, '
            + 'and click the <b>Continue</b> button.</p> <p>Enter the verification code sent to '
            + 'your email address and create a new password. '
            + 'Confirm your password and click the <b>Reset Password</b> button.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Authentication,
        order: 18,
        conditions: [HelpConditional.Users],
        bookmark: 'verification-code-not-working',
        title: helpTitle('verification-code-not-working'),
        body: '<p>Verification codes are sent via text message or email automatically. In the '
            + "case that you didn't receive a code, or the code is not working, you can click "
            + '<em>Try again</em> (under the code field) after 60 seconds.</p>'
            + "<p>If the verification code still isn't working, confirm that you are using the "
            + 'most recent code that you have received.</p>'
    })
];
